export default function mapInputToConfiguration(i) {
  // TODO lägg till felhantering för dålig input?

  // Copy the input to avoid mutation
  const input = JSON.parse(JSON.stringify(i));

  const {
    type,
    size,
    season,
    isFoundationAvailable,
    typeOfFoundation,
    constructionSupport
  } = input;

  let foundation = null;

  if (isFoundationAvailable === true) {
    foundation = "already_completed";
  } else if (isFoundationAvailable === false && typeOfFoundation) {
    foundation = typeOfFoundation;
  }

  const configuration = {
    type,
    size,
    season,
    foundation,
    constructionSupport
  };

  return configuration;
}
